import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "emp-notice" }
const _hoisted_2 = { class: "emp-header" }
const _hoisted_3 = { class: "emp-content" }
const _hoisted_4 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_5 = {
  key: 1,
  class: "notice-list"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "item-title" }
const _hoisted_8 = {
  key: 1,
  class: "new-badge"
}
const _hoisted_9 = { class: "item-author" }
const _hoisted_10 = { class: "item-date" }
const _hoisted_11 = {
  key: 2,
  class: "empty-state"
}

import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import axios from 'axios';

interface Notice {
  nc_idx: number;
  nc_type: 'ADMIN' | 'CENTER';
  nc_category: string;
  nc_sisul_name: string | null;
  nc_writer_name: string;
  nc_title: string;
  nc_wdate: string;
  file_count: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'EmpNotice',
  setup(__props) {

const router = useRouter();
const loading = ref(false);
const notices = ref<Notice[]>([]);

const loadNotices = async () => {
  loading.value = true;
  try {
    const response = await axios.get('/api/notice/list', {
      params: { page: 1, limit: 50 },
      withCredentials: true
    });
    
    if (response.data.success) {
      notices.value = response.data.notices;
    }
  } catch (error) {
    console.error('공지사항 로드 오류:', error);
  } finally {
    loading.value = false;
  }
};

const goBack = () => {
  router.push('/emp/home');
};

const goToDetail = (notice: Notice) => {
  router.push(`/emp/notice/${notice.nc_idx}`);
};

const formatDate = (date: string) => {
  if (!date) return '';
  const d = new Date(date);
  return `${d.getMonth() + 1}/${d.getDate()}`;
};

const formatListDate = (date: string) => {
  if (!date) return '-';
  const d = new Date(date);
  return `${d.getFullYear()}.${String(d.getMonth()+1).padStart(2,'0')}.${String(d.getDate()).padStart(2,'0')}`;
};

const isNew = (date: string) => {
  if (!date) return false;
  const d = new Date(date);
  const now = new Date();
  return (now.getTime() - d.getTime()) < 3 * 24 * 60 * 60 * 1000;
};

const getCategoryText = (category: string) => {
  switch (category) {
    case 'NOTICE': return '공지';
    case 'UPDATE': return '업데이트';
    case 'EVENT': return '이벤트';
    case 'URGENT': return '긴급';
    default: return category;
  }
};

onMounted(() => {
  loadNotices();
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "back-btn",
        onClick: goBack
      }, [
        _createVNode(_component_v_icon, {
          size: "24",
          color: "white"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode("mdi-arrow-left", -1)
          ]))]),
          _: 1
        })
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "header-title" }, "공지사항", -1)),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "header-spacer" }, null, -1))
    ]),
    _createElementVNode("div", _hoisted_3, [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              color: "primary"
            })
          ]))
        : (notices.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notices.value, (notice) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: notice.nc_idx,
                  class: "notice-item",
                  onClick: ($event: any) => (goToDetail(notice))
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass(['mini-badge', `badge-${notice.nc_category.toLowerCase()}`])
                  }, _toDisplayString(getCategoryText(notice.nc_category)), 3),
                  _createElementVNode("span", _hoisted_7, [
                    _createTextVNode(_toDisplayString(notice.nc_title) + " ", 1),
                    (notice.file_count > 0)
                      ? (_openBlock(), _createBlock(_component_v_icon, {
                          key: 0,
                          size: "12",
                          color: "grey",
                          class: "ml-1"
                        }, {
                          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                            _createTextVNode("mdi-attachment", -1)
                          ]))]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (isNew(notice.nc_wdate))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, "N"))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(notice.nc_type === 'ADMIN' ? '관리자' : notice.nc_sisul_name || '-'), 1),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(formatListDate(notice.nc_wdate)), 1)
                ], 8, _hoisted_6))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(_component_v_icon, {
                size: "48",
                color: "#ccc"
              }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode("mdi-bulletin-board", -1)
                ]))]),
                _: 1
              }),
              _cache[5] || (_cache[5] = _createElementVNode("p", null, "공지사항이 없습니다", -1))
            ]))
    ])
  ]))
}
}

})